<template>
  <v-container fluid class="ma-4 mt-8">
    <v-row>
      <v-col cols="12">
        <div class="mr-8 home-content" v-html="homeContent"></div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'LoggedInStart',

  components: {},

  data: () => ({
    contentLocale: ''
  }),

  computed: {
    ...mapGetters('app', ['homeContent', 'locale'])
  },

  mounted() {
    if (!this.startContent || this.locale!==this.contentLocale) {
      this.$store.dispatch('app/loadHomeContent', this.locale)
      this.contentLocale = this.locale
    }
  },

  watch: {
    locale() {
      this.$store.dispatch('app/loadHomeContent', this.locale)
      this.contentLocale = this.locale
    }
  }
}
</script>

<style scoped>
  .home-content p {
    word-wrap: break-word;
  }
</style>